import { MotivoScadenzaAuto } from "../tipologiche/motivo-scadenza-auto";

export class ScadenzeTrovate { 
    selezionato: boolean;
    tipoData: any;
    data: number;
    giornoPatrono: boolean;
    sospensionePersonalizzata: boolean;
    sospensioneFeriale: boolean;
    termineLibero: boolean;
    abbreviazioneTermini: boolean;
    id: string;
    motivoAdempimento: MotivoScadenzaAuto;
    tipoAdempimento: string;
    constructor(scadenzeTrovate){
        this.selezionato = false;
        this.tipoData = scadenzeTrovate.tipoData ? scadenzeTrovate.tipoData : null;
        this.data = scadenzeTrovate.data ? scadenzeTrovate.data : null;
        this.id = scadenzeTrovate.id;
        this.giornoPatrono = scadenzeTrovate.giornoPatrono;
        this.motivoAdempimento = scadenzeTrovate.motivoAdempimento ? scadenzeTrovate.motivoAdempimento : null;
        this.tipoAdempimento = scadenzeTrovate.tipoAdempimento ? scadenzeTrovate.tipoAdempimento : null;
        this.sospensionePersonalizzata = scadenzeTrovate.sospensionePersonalizzata;
        this.sospensioneFeriale = scadenzeTrovate.sospensioneFeriale;
        this.termineLibero = scadenzeTrovate.termineLibero;
        this.abbreviazioneTermini = scadenzeTrovate.abbreviazioneTermini;
    }
}